import { WidgetType } from '../core/template-definition.model';
import { WidgetTypeComponentMapType } from '../core/widget-type-component-map-type';
import {
    ScCompBonusWidgetComponent,
    ScCompConditionWidgetComponent,
    ScCompModifierWidgetComponent,
    ScCompQualifiersWidgetComponent,
    ScFyiWidgetComponent,
    ScGridComponent,
    ScOverallScoreWidgetComponent,
    ScRanksWidgetComponent,
} from '../widgets';

export const widgetTypeComponentMap: WidgetTypeComponentMapType = {
    [WidgetType.SCORECARD_GRID]: ScGridComponent,
    [WidgetType.FYI_GRID]: ScFyiWidgetComponent,
    [WidgetType.OVERALL_SCORE_GRID]: ScOverallScoreWidgetComponent,
    [WidgetType.RANKINGS_GRID]: ScRanksWidgetComponent,
    [WidgetType.COMPENSATION_CONDITION]: ScCompConditionWidgetComponent,
    [WidgetType.COMPENSATION_QUALIFIERS]: ScCompQualifiersWidgetComponent,
    [WidgetType.COMPENSATION_MODIFIERS]: ScCompModifierWidgetComponent,
    [WidgetType.COMPENSATION_BONUS]: ScCompBonusWidgetComponent,
    [WidgetType.METRIC_TREND_CHART]: null,
    [WidgetType.YOUR_TEAM]: null,
};
